import { callLambdaApi } from "../callLambdaApi";
import { ApiNames, Methods } from "../constants";

export class ModelSearchApiCommunicator {
  fetch(id) {
    console.log("fetch()");
    return callLambdaApi({
      method: Methods.GET,
      apiName: ApiNames.Submissions,
      path: this._buildBaseURL() + `/${id}`,
    });
  }


  /**
   * @param {object} requestBody
   * @param {string} requestBody.modelName
   */
  create(
    requestBody = {
      fileName: "New Model Search Model",
    }
  ) {
    return callLambdaApi({
      method: Methods.POST,
      apiName: ApiNames.Submissions,
      path: this._buildBaseURL(),
      payload: {
        body: {
          ...requestBody,
        },
      },
    });
  }

  /**
   *
   * @param {string} id
   * @returns {Promise<{
   * data: {
   * datasetId: string;
   * datasetName: string;
   * datasetType: string;
   * dateAdded: number;
   * modelIds: string[];
   * models: object[];
   * orgId: string;
   * userId: string;
   * printer: string;
   * material: string;
   * }
   * }>}
   */
  // fetch(id) {
  //   console.log("fetch()");
  //   return callLambdaApi({
  //     method: Methods.GET,
  //     apiName: ApiNames.Submissions,
  //     path: this._buildBaseURL() + `/${id}`,
  //   });
  // }

  // fetchResult(id, resultId) {
  //   console.log("fetch()");
  //   return callLambdaApi({
  //     method: Methods.GET,
  //     apiName: ApiNames.Submissions,
  //     path: this._buildBaseURL() + `/${id}/result/${resultId}`,
  //   });
  // }

  /**  @returns {Promise<import('api').GETResponse<import("models").MLModel[]>} */
  list() {
    console.log("list()");
    return callLambdaApi({
      method: Methods.GET,
      apiName: ApiNames.Submissions,
      path: this._buildBaseURL(),
    });
  }

  delete(id) {
    return callLambdaApi({
      method: Methods.DELETE,
      apiName: ApiNames.Submissions,
      path: this._buildBaseURL() + `/${id}`,
    });
  }


  /**
   * Returns the default serverless api endpoint
   * using the instance's project and model ids.
   * @private
   */
  _buildBaseURL() {
    return `/pwam/private/search`;
  }
}
